module.exports = __webpack_public_path__ + "static/media/Highlands2.ff94515c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Environments/Highlands2.jpg
// module id = 210
// module chunks = 0